import { trackSDK } from './core';

// Convenience exports — module-level functions bound to the singleton
export const init = trackSDK.init.bind(trackSDK);
export const event = trackSDK.event.bind(trackSDK);
export const pv = trackSDK.pv.bind(trackSDK);
export const trace = trackSDK.trace.bind(trackSDK);
export const captureError = trackSDK.captureError.bind(trackSDK);
export const stay = trackSDK.stay.bind(trackSDK);
export const stayStart = trackSDK.stayStart.bind(trackSDK);
export const stayEnd = trackSDK.stayEnd.bind(trackSDK);
export const login = trackSDK.login.bind(trackSDK);
export const logout = trackSDK.logout.bind(trackSDK);

// Framework integration helpers
export { setupVueErrorHandler } from './modules/vue-error';

// Re-export the singleton instance
export { trackSDK };

// Re-export adapter helpers
export { BatchedAdapter } from './batcher';
export { DedupAdapter } from './deduper';
export { SamplingAdapter } from './sampler';

// Re-export stay helpers
export { StayTimer } from './modules/stay';

// Re-export types
export type {
  TrackInitOptions,
  PvOptions,
  TraceData,
  TrackPublicAPI,
  TrackerAdapter,
  PageStayOptions,
  StayReportOptions,
} from './types';
